export default __webpack_public_path__ + "static/media/blue-investing.cafc7a6a.svg";